export type PermissionActionDefinition = {
  name: string;
  description: string;
};

export type PermissionResourceDefinition = {
  name: string;
  code: string;
  type: 'MENU';
  description: string;
  actions: PermissionActionDefinition[];
};

const action = (
  name: string,
  description: string,
): PermissionActionDefinition => ({
  name,
  description,
});

export const SOCIAL_INSURANCE_CENTER_PERMISSION_RESOURCES = [
  {
    name: '我的社保',
    code: 'social-insurance-center-my',
    type: 'MENU',
    description: '控制我的社保页面访问和查询',
    actions: [action('view', '查看'), action('query', '查询')],
  },
  {
    name: '团队社保',
    code: 'social-insurance-center-team',
    type: 'MENU',
    description: '控制团队社保页面访问、查询和下钻',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('open-drilldown', '打开下钻'),
    ],
  },
  {
    name: '社保工作台',
    code: 'social-insurance-center-workbench',
    type: 'MENU',
    description: '控制社保工作台页面访问和风险下钻',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('open-drilldown', '打开下钻'),
      action('open-risk-action', '打开风险处理'),
    ],
  },
  {
    name: '我的审批',
    code: 'social-insurance-center-approval',
    type: 'MENU',
    description: '控制社保中心我的审批页面访问、审批任务查询和业务单据回跳',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('open-source', '回跳业务单据'),
    ],
  },
  {
    name: '参保方案',
    code: 'social-insurance-center-policies',
    type: 'MENU',
    description: '控制参保方案页面访问和方案维护',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-policy', '新增方案'),
      action('edit-policy', '编辑方案'),
      action('view-policy', '查看方案'),
      action('delete-policy', '删除方案'),
      action('export-policies', '导出方案'),
    ],
  },
  {
    name: '参保档案',
    code: 'social-insurance-center-accounts',
    type: 'MENU',
    description: '控制参保档案页面访问和档案维护',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-account', '新增档案'),
      action('edit-account', '编辑档案'),
      action('view-account', '查看档案'),
      action('delete-account', '删除档案'),
      action('export-accounts', '导出档案'),
    ],
  },
  {
    name: '参保办理',
    code: 'social-insurance-center-changes',
    type: 'MENU',
    description: '控制参保办理页面访问和办理流程',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-change', '新增变更'),
      action('edit-change', '编辑变更'),
      action('submit-change', '提交变更'),
      action('cancel-change', '取消变更'),
      action('complete-change', '完成变更'),
      action('delete-change', '删除办理记录'),
      action('export-changes', '导出变更'),
    ],
  },
  {
    name: '社保缴费',
    code: 'social-insurance-center-bills',
    type: 'MENU',
    description: '控制社保缴费页面访问、账单生成和回单处理',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-bill', '新增台账'),
      action('view-detail', '查看详情'),
      action('generate-bill', '生成账单'),
      action('reconcile-bill', '登记对账'),
      action('confirm-bill', '确认账单'),
      action('upload-receipt', '上传回单'),
      action('preview-receipt', '预览回单'),
      action('download-receipt', '下载回单'),
      action('archive-bill', '归档账单'),
      action('delete-bill', '删除台账'),
      action('export-bill-items', '导出明细'),
      action('export-bills', '导出账单'),
    ],
  },
  {
    name: '社保操作审计',
    code: 'social-insurance-center-audits',
    type: 'MENU',
    description: '控制社保操作审计页面访问和导出',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('view-detail', '查看详情'),
      action('export-audits', '导出审计'),
    ],
  },
  {
    name: '审批流程设置',
    code: 'social-insurance-center-workflow-settings',
    type: 'MENU',
    description: '控制社保审批流程设置页面访问和流程启停保存',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('configure-workflow', '设置审批流程'),
      action('save-workflow-settings', '保存审批流程设置'),
    ],
  },
] as const satisfies readonly PermissionResourceDefinition[];

export const SOCIAL_INSURANCE_PERMISSION_RESOURCE_CODES = {
  my: 'social-insurance-center-my',
  team: 'social-insurance-center-team',
  workbench: 'social-insurance-center-workbench',
  approval: 'social-insurance-center-approval',
  policies: 'social-insurance-center-policies',
  accounts: 'social-insurance-center-accounts',
  changes: 'social-insurance-center-changes',
  bills: 'social-insurance-center-bills',
  audits: 'social-insurance-center-audits',
  workflowSettings: 'social-insurance-center-workflow-settings',
} as const;
